module.exports = __webpack_public_path__ + "assets/FrenchWa.92faa0f7.svg";